<template>
    <div class="FM">FM</div>
</template>

<script>
    export default {
        name: 'FM',
        data() {
            return {}
        },
        methods: {},
        computed: {},
        components: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FM/FM.vue